(() => {
  const mobileViewport = window.matchMedia('(max-width: 749px)');
  const interactiveSelector = 'button, a, input, select, textarea, label, [role="button"], [data-wn-bubble], [data-wn-bubble-trigger], [data-wn-bubble-panel]';
  const movementThreshold = 12;

  const closestInteractive = (target) => {
    if (!(target instanceof Element)) return null;
    return target.closest(interactiveSelector);
  };

  function enhanceGallery(gallery) {
    if (!(gallery instanceof HTMLElement) || gallery.dataset.wnMobileTapReady === 'true') return;

    const stage = gallery.querySelector('[data-media-stage]');
    const track = gallery.querySelector('[data-wn-gallery-track]');
    const previous = gallery.querySelector('[data-wn-gallery-previous]');
    const next = gallery.querySelector('[data-wn-gallery-next]');

    if (!stage || !track || !previous || !next) return;

    gallery.dataset.wnMobileTapReady = 'true';
    let tap = null;

    track.addEventListener('pointerdown', (event) => {
      if (!mobileViewport.matches || closestInteractive(event.target)) return;
      if (typeof event.button === 'number' && event.button !== 0) return;

      tap = {
        id: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        moved: false
      };
    }, { passive: true });

    track.addEventListener('pointermove', (event) => {
      if (!tap || tap.id !== event.pointerId) return;

      const deltaX = event.clientX - tap.startX;
      const deltaY = event.clientY - tap.startY;
      if (Math.hypot(deltaX, deltaY) > movementThreshold) tap.moved = true;
    }, { passive: true });

    track.addEventListener('pointercancel', () => {
      tap = null;
    }, { passive: true });

    track.addEventListener('pointerup', (event) => {
      if (!tap || tap.id !== event.pointerId) return;

      const candidate = tap;
      tap = null;

      if (!mobileViewport.matches || candidate.moved || closestInteractive(event.target)) return;

      const rect = stage.getBoundingClientRect();
      const insideStage = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!insideStage) return;

      if (event.clientX < rect.left + (rect.width / 2)) previous.click();
      else next.click();
    }, { passive: true });
  }

  function boot(scope = document) {
    const root = scope?.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-wn-gallery]').forEach(enhanceGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
